import React from 'react'

export default function Financiero() {
  return (
    <div>
      Financiero
    </div>
  )
}
